import { ROUTES } from "@/constants/routes";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import { Spinner } from "@cohesive/ui-components";
import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { beginTemplateSignup, signupReturnTo } from "./templateSignupIntake";

const SignUpPage: React.FC = () => {
  const { isAuthenticated } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(ROUTES.HOME);
    }
  }, [isAuthenticated]);

  return (
    <div className="flex items-center justify-center h-dvh">
      <Spinner size="xl" />
    </div>
  );
};

function getLoginHint() {
  try {
    return new URLSearchParams(window.location.search).get("e");
  } catch (error) {
    return null;
  }
}

export default withAuthenticationRequired(SignUpPage, {
  returnTo: () => signupReturnTo(window.location.search),
  onBeforeAuthentication: async () =>
    beginTemplateSignup(window.location.search),
  loginOptions: {
    authorizationParams: {
      screen_hint: "signup",
      login_hint: getLoginHint() ?? undefined,
    },
  },
});
